export const tripsFeatureKey = 'trips';
